import { useState } from 'react';
import useWizardFormCtx from '../../ctx-provider/useWizardFormCtx';
import WizardFormBo from '../../ctx-provider/WizardFormBo';
import AntragConsumer from '../../../../../consumer/antrag/AntragConsumer';
import useRkCtxBo from '../../../../../consumer/rk/ctx-provider/useRkCtx';

const useBtnAntragEinreichen = () => {
    const { wizardFormBo, fireWizardFormBo, handleNextPage } = useWizardFormCtx();
    const rkCtxBo = useRkCtxBo();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const antragEinreichen = (error: boolean) => {
        const wizardFormDto = WizardFormBo.exportFormulardaten(wizardFormBo);

        if (error === false) {
            setLoading(true);

            const rkResult = wizardFormBo.angebot.produktMitSchutzbrief ? rkCtxBo.paketMitSchutzbrief : rkCtxBo.paketOhneSchutzbrief;
            if (!rkResult) {
                throw Error('RK-Ergebnis liegt nicht vor.');
            }
            AntragConsumer.antragEinreichen(wizardFormDto, rkResult)
                .then(vorgnr => {
                    wizardFormBo.eingereicht.vorgangsnumer = vorgnr;
                    fireWizardFormBo(wizardFormBo);
                    setError(false);
                    handleNextPage();
                }).catch(error => {
                    setError(true);
                }).finally(() => {
                    setLoading(false);
                });
        }
    }

    return {
        loading,
        error,
        antragEinreichen
    }

}

export default useBtnAntragEinreichen;